export const INSERT_POTENTIAL_PROFILE_MUTATION = `
  mutation InsertPotentialProfile($input: PotentialProfileInsertInput!) {
    insertPotentialProfile(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_POTENTIAL_PROFILE_MUTATION = `
  mutation DeletePotentialProfile($filter: String!, $input: PotentialProfileDeleteInput!) {
    deletePotentialProfile(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;

/**
 * Used by the real "Transfer to Conditional" action, which the Angular source
 * only stubbed. Only wires the fields this transfer needs (SourcePotentialProfileId,
 * name/contact/designation/experience/source, HiringDepartmentId, and a client-built
 * InterviewPanelJson); the full ConditionalOffer read/write layer belongs to
 * hr-conditional-offers.
 */
export const INSERT_CONDITIONAL_OFFER_MUTATION = `
  mutation InsertConditionalOffer($input: ConditionalOfferInsertInput!) {
    insertConditionalOffer(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;
